import { TableRowActions } from '../../../Table'

function RequestArchivedPipelinesModalRowActions({
  disabled,
  selected,
  ...restProps
}) {
  return (
    <TableRowActions
      {...restProps}
      checked={selected}
      disabled={disabled && !selected}
      selected={false}
    />
  )
}

export default RequestArchivedPipelinesModalRowActions
